import { Checkbox } from "@dune/ui";
import { getCheckboxesToHide } from "@dune/utils";
import { actionBuildingTypeCheckboxes } from "@dune/vars";
import { useFormContext, useWatch } from "react-hook-form";
import { buildingDetailsDefautValues } from "./useConstructionSiteDetailsForm";

type ActionBuildingTypesDetailsContainerProps = {
	isComplementary?: boolean;
	isGFA?: boolean;
};

const ActionBuildingTypesDetailsContainer = ({
	isComplementary = false,
	isGFA = false,
}: ActionBuildingTypesDetailsContainerProps) => {
	const {
		control,
		setValue,
		clearErrors,
		formState: { errors },
	} = useFormContext();

	const actionsValue = useWatch({
		control,
		name: isComplementary ? "actions.complementaryActions" : "actions",
	});

	const { buildingTypeCheckboxesToHide } = getCheckboxesToHide(
		actionsValue.types,
	);

	const error = isComplementary
		? (
				errors.actions as {
					complementaryActions?: { buildingType?: { message: string } };
				}
			)?.complementaryActions?.buildingType
		: (errors.actions as { buildingType?: { message: string } })?.buildingType;

	return (
		<div>
			{error?.message && (
				<span className="text-red-500 text-sm">
					{error?.message?.toString()}
				</span>
			)}
			<div className="grid grid-cols-3 gap-2">
				{actionBuildingTypeCheckboxes
					.filter((buildingTypeCheckbox) => {
						if (isGFA) {
							return buildingTypeCheckbox.value !== "APPARTMENT";
						}
						return true;
					})
					.map((buildingTypeCheckbox) => {
						const toHide =
							buildingTypeCheckboxesToHide.includes(
								buildingTypeCheckbox.value,
							) ||
							(actionsValue.buildingType &&
								actionsValue.buildingType !== buildingTypeCheckbox.value);
						return toHide ? (
							<div key={buildingTypeCheckbox.value} />
						) : (
							<Checkbox
								id={
									isComplementary
										? `complementary-${buildingTypeCheckbox.value}`
										: buildingTypeCheckbox.value
								}
								key={buildingTypeCheckbox.value}
								label={buildingTypeCheckbox.label}
								checked={
									actionsValue?.buildingType === buildingTypeCheckbox.value
								}
								onCheckedChange={(checked) => {
									if (isComplementary) {
										setValue("actions.complementaryActions", {
											types: actionsValue.types,
											...(checked && {
												buildingType: buildingTypeCheckbox.value,
											}),
										});
									} else {
										setValue("actions", {
											types: actionsValue.types,
											buildingDetails: buildingDetailsDefautValues,
											underpinningExistingFoundations: false,
											interventionOnLoadBearingStructure: false,
											socialLandlordRental: false,
											hasComplementaryActions: false,
											complementaryActions: undefined,
											buildingType: checked
												? buildingTypeCheckbox.value
												: undefined,
										});
										setValue("totalAmountTTC", undefined);
										setValue("totalAmountHT", undefined);
										clearErrors([
											"actions.buildingDetails",
											"totalAmountTTC",
											"totalAmountHT",
											"ccmi",
										]);
									}
								}}
								className="border-gray-300 disabled:bg-gray-100"
							/>
						);
					})}
			</div>
		</div>
	);
};
export default ActionBuildingTypesDetailsContainer;
